import { InquiryButtonLink as ButtonLink } from "../inquiry-origin.js";
import { InteriorHero } from "../page-components.js";
import { SampleHeroCard } from "../sample-reports.js";
import { InteriorClosing } from "../interior-components.js";
import { RecruitingServices } from "../recruiting-services.js";
import { AudienceArticles } from "../audience-articles.js";
import "../audience-page.css";

const hiringPoints = [
  [
    "Define the work",
    "Clarify the responsibilities, expectations and environment the person will work in.",
  ],
  ["Find and assess talent", "Find relevant professionals and assess their technical experience."],
  [
    "Explore the experience",
    "Understand how the person’s work and decisions relate to your hiring needs.",
  ],
  [
    "Prepare the conversation",
    "Focus the interview on relevant strengths and questions that need a closer look.",
  ],
] as const;

export function EmployersPage() {
  return (
    <div className="employers-page audience-page">
      <div className="interior-redesign">
        <InteriorHero
          className="profile-hero"
          eyebrow="For employers · Cybersecurity recruiting"
          title="Understand the person behind the resume"
          copy="We help you define the role, find and assess relevant talent, understand how a candidate’s experience relates to your hiring needs, and prepare for the conversation ahead."
          visual={<SampleHeroCard report="dossier" inlineFictionLabel />}
          supportingContent={
            <dl className="employer-hero-points" aria-label="How we help with your hire">
              {hiringPoints.map(([title, copy]) => (
                <div key={title}>
                  <dt>{title}</dt>
                  <dd>{copy}</dd>
                </div>
              ))}
            </dl>
          }
        >
          <ButtonLink href="/contact?kind=EMPLOYER">Discuss your needs</ButtonLink>
          <ButtonLink href="/our-process/examples" variant="secondary">
            See Example Reports
          </ButtonLink>
          <p className="hero-action-helper">You don’t need a finished job description to start.</p>
        </InteriorHero>
      </div>
      <div className="home-page">
        <RecruitingServices />
      </div>
      <AudienceArticles audience="employers" />
      <div className="interior-redesign">
        <InteriorClosing
          title="Tell us about your Cybersecurity hiring needs"
          href="/contact?kind=EMPLOYER"
          button="Find Cybersecurity Talent"
        />
      </div>
    </div>
  );
}
